module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ARl"
    }
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "images/himg-6-1.jpg",
      "src": "images/himg-6-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "pz9-3"
    }
  }, [_c('b', [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("B")])]), _vm._v("efore Jesus began His earthly ministry, the Spirit led Him into the wilderness where He would be tempted by the devil. After Jesus had fasted for forty days and forty nights, Satan challenged Him to turn the desert rocks into bread, to meet His needs in His own time and His own way, without considering God’s timing or ways. But when Jesus faced the temptation to create bread for Himself—and just as in the two subsequent wilderness temptations—Jesus responded to Satan’s words with the powerful words of God. Each time Jesus began with “It is written,” and each time Jesus quoted God’s truth and silenced the enemy. Jesus knew that God would provide the needed food at the right time. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz9-5"
    }
  }, [_vm._v("Christians must know what God’s Word says. They also must be willing to trust His timing. When you choose to build your life on His Word, you can—as Jesus did—stand strong against any temptation you find yourself facing. You can also trust Him to provide for you according to His perfect will. Follow Jesus’ example and confront every temptation with “It is written.” You will find strength in God’s true Word and the faith to trust in His timing. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba7a93e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter04.vue
// module id = 75
// module chunks = 0